import { render, staticRenderFns } from "./MenuUser.vue?vue&type=template&id=198fc0cd&scoped=true"
import script from "./MenuUser.vue?vue&type=script&lang=js"
export * from "./MenuUser.vue?vue&type=script&lang=js"
import style0 from "./MenuUser.vue?vue&type=style&index=0&id=198fc0cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198fc0cd",
  null
  
)

export default component.exports